var chunkMapping = {
	"860": [
		20124,
		62797,
		88296,
		93947
	],
	"5228": [
		75228
	],
	"7126": [
		4446,
		17418,
		49394,
		85646
	],
	"7293": [
		7293
	],
	"8165": [
		29870,
		31930,
		47538,
		51113,
		82893,
		89982
	],
	"8186": [
		99406
	]
};
var idToExternalAndNameMapping = {
	"4446": [
		"default",
		"./utils/common",
		18579
	],
	"7293": [
		"default",
		"./AppLoader",
		18579
	],
	"17418": [
		"default",
		"./appSlice",
		18579
	],
	"20124": [
		"default",
		"./components/NotificationBell",
		18579
	],
	"29870": [
		"default",
		"./helpers/PageTitle",
		18579
	],
	"31930": [
		"default",
		"./components/CustomNoDataOverlay",
		18579
	],
	"47538": [
		"default",
		"./helpers/CustomModalStyle",
		18579
	],
	"49394": [
		"default",
		"./store",
		18579
	],
	"51113": [
		"default",
		"./helpers/PageContainer",
		18579
	],
	"62797": [
		"default",
		"./components/ColumnSelectorStyle",
		18579
	],
	"75228": [
		"default",
		"./utils/constants",
		18579
	],
	"82893": [
		"default",
		"./helpers/PageSubHeader",
		18579
	],
	"85646": [
		"default",
		"./headerSlice",
		18579
	],
	"88296": [
		"default",
		"./helpers/CustomSearch",
		18579
	],
	"89982": [
		"default",
		"./helpers/Breadcrumb",
		18579
	],
	"93947": [
		"default",
		"./helpers/CustomDropDownSelect",
		18579
	],
	"99406": [
		"default",
		"./providers/FlagsmithProvider",
		18579
	]
};
var idToRemoteMap = {
	"4446": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"7293": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"17418": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"20124": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"29870": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"31930": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"47538": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"49394": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"51113": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"62797": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"75228": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"82893": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"85646": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"88296": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"89982": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"93947": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	],
	"99406": [
		{
			"externalType": "script",
			"name": "COMMON_APP",
			"externalModuleId": 18579
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}